import request from './request'


export function loginApi(data) {
    return request({
        url: '/login',
        method: 'post',
        data
    })
}

export function accountUpdate(data) {
    return request({
        url: '/account/update',
        method: 'post',
        data
    })
}

export function userInfo(data) {
    return request({
        url: '/user/profile',
        method: 'post',
        data
    })
}

// 用户查询（客服列表）
export function userList(data) {
    return request({
        url: '/user/list',
        method: 'post',
        data
    })
}

export function userUpdate(data) {
    return request({
        url: '/user/update',
        method: 'post',
        data
    })
}

export function userDelete(data) {
    return request({
        url: '/user/delete',
        method: 'post',
        data
    })
}

// 角色列表
export function roleList(data) {
    return request({
        url: '/role/list',
        method: 'post',
        data
    })
}

// 角色操作(添加角色，修改角色，角色分配权限)
export function roleUpdate(data) {
    return request({
        url: '/role/update',
        method: 'post',
        data
    })
}

export function roleDelete(data) {
    return request({
        url: '/role/delete',
        method: 'post',
        data
    })
}

// 菜单列表
export function getMenuList(data) {
    return request({
        url: '/menu/list',
        method: 'post',
        data
    })
}

// 根据角色查询菜单列表
export function menuTree(data) {
    return request({
        url: '/menu/tree',
        method: 'post',
        data
    })
}

// 菜单修改/添加
export function menuUpdate(data) {
    return request({
        url: '/menu/update',
        method: 'post',
        data
    })
}

// 菜单删除
export function menuDelete(data) {
    return request({
        url: '/menu/delete',
        method: 'post',
        data
    })
}


// 发送验证码
export function sms(data) {
    return request({
        url: '/sms',
        method: 'post',
        data
    })
}


// 修改密码
export function logout(data) {
    return request({
        url: '/logout',
        method: 'post',
        data
    })
}

export function changePassword(data) {
    return request({
        url: '/logout',
        method: 'post',
        data
    })
}

// 开发者列表
export function followList(data) {
    return request({
        url: '/followUp/list',
        method: 'post',
        data
    })
}
// 开发者回访
export function followUpdate(data) {
    return request({
        url: '/followUp/update',
        method: 'post',
        data
    })
}

// 码牌列表
export function codePlateList(data) {
    return request({
        url: '/codePlate/list',
        method: 'post',
        data
    })
}

// 生成码牌
export function codePlateAdd(data) {
    return request({
        url: '/codePlate/add',
        method: 'post',
        data
    })
}

// 生成码牌
export function codePlateUpdate(data) {
    return request({
        url: '/codePlate/update',
        method: 'post',
        data
    })
}

// 客户查询
export function customerDetail(data) {
    return request({
        url: '/customer/detail',
        method: 'post',
        data
    })
}

export function checkout(data) {
    return request({
        url: '/checkout',
        method: 'post',
        data
    })
}

export function deleteShopPrinter(data) {
    return request({
        url: '/delete/shop/printer',
        method: 'post',
        data
    })
}

export function deleteSupplierPrinter(data) {
    return request({
        url: '/delete/supplier/printer',
        method: 'post',
        data
    })
}

export function clientUpdate(data) {
    return request({
        url: '/client/update',
        method: 'post',
        data
    })
}

export function deleteClient(data) {
    return request({
        url: '/client/delete',
        method: 'post',
        data
    })
}

export function shopList(data) {
    return request({
        url: '/shop/list',
        method: 'post',
        data
    })
}

export function getShopDetail(data) {
    return request({
        url: '/shop/detail',
        method: 'post',
        data
    })
}

/**
 * 门店操作（恢复推送，停止推送）
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function shopOperate(data) {
    return request({
        url: '/shop/operate',
        method: 'post',
        data
    })
}

/**
 * 商户刷新
 * @param data
 * @returns {*}
 */
export function shopRefresh(data) {
    return request({
        url: '/shop/refresh',
        method: 'post',
        data
    })
}

/**
 * 门店绑定
 * @param data
 * @returns {*}
 */
export function shopBind(data) {
    return request({
        url: '/shop/bind',
        method: 'post',
        data
    })
}

export function shopStat(data) {
    return request({
        url: '/shop/stat',
        method: 'post',
        data
    })
}

/**
 * 订阅操作（延长，转移）
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function subscriptionOperate(data) {
    return request({
        url: '/shop/subscription/operate',
        method: 'post',
        data
    })
}

export function deviceList(data) {
    return request({
        url: '/device/list',
        method: 'post',
        data
    })
}

export function deviceBlacklist(data) {
    return request({
        url: '/device/blacklist',
        method: 'post',
        data
    })
}

export function deviceUpgradeList(data) {
    return request({
        url: '/device/upgrade/list',
        method: 'post',
        data
    })
}

export function deviceUpgradeStat(data) {
    return request({
        url: '/device/upgrade/stat',
        method: 'post',
        data
    })
}

export function deviceBlacklistDelete(data) {
    return request({
        url: '/device/blacklist/delete',
        method: 'post',
        data
    })
}

export function deviceRecharge(data) {
    return request({
        url: '/device/recharge',
        method: 'post',
        data
    })
}

export function devicePrint(data) {
    return request({
        url: '/device/print',
        method: 'post',
        data
    })
}

export function devicePrintDetail(data) {
    return request({
        url: '/device/print/detail',
        method: 'post',
        data
    })
}

export function deviceRefresh(data) {
    return request({
        url: '/device/refresh',
        method: 'post',
        data
    })
}



// 工单查询
export function workOrderList(data) {
    return request({
        url: '/work_order/list',
        method: 'post',
        data
    })
}

// 工单修改
export function workOrderUpdate(data) {
    return request({
        url: '/work_order/update',
        method: 'post',
        data
    })
}

// 工单发送消息
export function sendMessage(data) {
    return request({
        url: '/work_order/send/message',
        method: 'post',
        data
    })
}

// 充值列表
export function rechargeList(data) {
    return request({
        url: '/recharge/list',
        method: 'post',
        data
    })
}

// 充值统计
export function rechargeStat(data) {
    return request({
        url: '/recharge/statistics',
        method: 'post',
        data
    })
}

export function rechargeUpdate(data) {
    return request({
        url: '/recharge/update',
        method: 'post',
        data
    })
}

export function operateList(data) {
    return request({
        url: '/operate/list',
        method: 'post',
        data
    })
}

export function covenantList(data) {
    return request({
        url: '/covenant/list',
        method: 'post',
        data
    })
}

export function covenantUpdate(data) {
    return request({
        url: '/covenant/update',
        method: 'post',
        data
    })
}

export function platformStatistics(data) {
    return request({
        url: '/platform/statistics',
        method: 'post',
        data
    })
}

export function freeList(data) {
    return request({
        url: '/device/free',
        method: 'post',
        data
    })
}

export function deviceOperate(data) {
    return request({
        url: '/device/operate',
        method: 'post',
        data
    })
}

export function deviceTakeStat(data) {
    return request({
        url: 'device/takeaway/stat',
        method: 'post',
        data
    })
}

export function deviceTakeExport() {
    return request({
        url: 'device/takeaway/export',
        method: 'get',
        responseType: 'blob',  // 关键：指定响应类型为 blob
        withCredentials: true,
        timeout: 60000
    })
}

export function deviceExport() {
    return request({
        url: 'device/export',
        method: 'get',
        responseType: 'blob',  // 关键：指定响应类型为 blob
        withCredentials: true,
        timeout: 60000
    })
}

export function deviceActivatePrint(data) {
    return request({
        url: '/device/activate/print',
        method: 'post',
        data
    })
}

export function pushOrderList(data) {
    return request({
        url: '/pushOrder/list',
        method: 'post',
        data
    })
}

export function firmwareUpgradeList(data) {
    return request({
        url: '/firmware/upgrade/list',
        method: 'post',
        data
    })
}

export function firmwareUpgradeOperate(data) {
    return request({
        url: '/firmware/upgrade/operate',
        method: 'post',
        data
    })
}

export function firmwareUpgradeDelete(data) {
    return request({
        url: '/firmware/upgrade/delete',
        method: 'post',
        data
    })
}

export function mealList(data) {
    return request({
        url: '/software/meal/list',
        method: 'post',
        data
    })
}

export function mealOperate(data) {
    return request({
        url: '/software/meal/operate',
        method: 'post',
        data
    })
}

export function mealDelete(data) {
    return request({
        url: '/software/meal/delete',
        method: 'post',
        data
    })
}

export function ossSign(data) {
    return request({
        url: '/oss/sign',
        method: 'post',
        data
    })
}

export function appList(data) {
    return request({
        url: '/platform/app/list',
        method: 'post',
        data
    })
}

export function appUpdate(data) {
    return request({
        url: '/platform/app/update',
        method: 'post',
        data
    })
}

export function systemLogList(data) {
    return request({
        url: '/log/system/list',
        method: 'post',
        data
    })
}

export function accountLogList(data) {
    return request({
        url: '/log/account/list',
        method: 'post',
        data
    })
}